// en_pms_reservations.ts
// Tłumaczenia dla PMS.Reservations.tsx i PMS.Reservations.Table.tsx

export const enPmsReservations = {

  summary: {
    total: "<strong>{{count}}</strong> total",
    checkedIn: "<strong>{{count}}</strong> checked-in",
    arrivingToday_one: "<strong>{{progress}}</strong> arrival today",
    arrivingToday_other: "<strong>{{progress}}</strong> arrivals today",
  },
  wizard: {
    review: {
      documentChecked: "Document checked",
      vipLevel: "VIP level",
      marketing: "Marketing consent",
      agreed: "Agreed",
      declined: "Declined",
      extras: "Extras",
      cityTax: "City tax",
      deposit: "Deposit",
      blockPackages: "Block packages",
    },
    selectedRooms_one: "Selected: {{count}} room.",
    selectedRooms_other: "Selected: {{count}} rooms.",
    suitableRooms_one: "Show only rooms suitable for {{count}} guest",
    suitableRooms_other: "Show only rooms suitable for {{count}} guests",
    groupRoomsSummary: "Group · {{rooms}}: {{numbers}}",
    groupOccupancyHint: "Xentros distributes guests across rooms automatically. You can adjust each room, but the totals must stay the same: adults: {{adults}}, children: {{children}}.",
  },

  title:     "Reservations",
  search:    "Search guest or ID...",

  // ── Akcje ─────────────────────────────────────────────────────────────────
  actions: {
    newReservation:     "New reservation",
    modifyReservation:  "Modify reservation",
    modify:             "Modify",
    cancelReservation:  "Cancel reservation",
    confirmCancellation:"Confirm cancellation",
    save:               "Save",
    saving:             "Saving...",
    cancelling:         "Cancelling...",
  },

  // ── Filtry statusów ───────────────────────────────────────────────────────
  status: {
    all:        "All",
    confirmed:  "Confirmed",
    inHouse:    "In-house",
    checkedOut: "Checked out",
    cancelled:  "Cancelled",
    noShow:     "No show",
    pending:    "Pending",
    waitlist:   "Waitlist",
    planned:    "Planned",
    completed:  "Completed",
    booked:     "Booked",
    active:     "Active",
    blocked:    "Blocked",
    departing:  "Departing today",
    authorized: "Authorized",
    captured:   "Captured",
    inProgress: "In progress",
  },

  // ── Typy rezerwacji ───────────────────────────────────────────────────────
  type: {
    individual: "Individual",
    group:      "Group",
    shared:     "Shared",
    direct:     "Direct",
  },

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    guest:      "Guest",
    room:       "Room",
    checkIn:    "Check-in",
    checkOut:   "Checkout",
    nights:     "Nights",
    adults:     "Adults",
    children:   "Children",
    rate:       "Rate",
    total:      "Total",
    deposit:    "Deposit",
    balance:    "Balance",
    notes:      "Notes",
  },

  // ── Sekcja historii ───────────────────────────────────────────────────────
  history: {
    title:      "Reservation history",
    auditTrail: "Audit trail for this reservation.",
    captured:   "Captured from reservations management.",
  },

  // ── Grupy rezerwacji ──────────────────────────────────────────────────────
  groups: {
    title:           "Groups and events",
    summary:         "Group summary",
    create:          "Create group",
    edit:            "Edit group",
    save:            "Save group",
    newReservation:  "New group reservation",
    editReservation: "Edit group reservation",
    groupedRooms:    "Group rooms",
    linkedEvents:    "Linked events",
    primaryEvent:    "Primary event",
    setPrimary:      "Set as primary",
    masterDetails:   "Primary details and main contact.",
    optionalEvents:  "Optional events linked to the group reservation.",
    editInline:      "Edit reservation details in place without leaving the workspace.",
    createTrack:     "Create and track grouped reservations and linked events in one view.",
    saved:           "Group reservation saved",
    updated:         "Group reservation updated",
  },

  // ── Overbooking ───────────────────────────────────────────────────────────
  overbooking: "Overbooking control",

  // ── Lista oczekujących ────────────────────────────────────────────────────
  waitlistMissingGuest: "The waitlist entry does not include a guest profile.",

  // ── Typy wydarzeń ─────────────────────────────────────────────────────────
  eventTypes: {
    meeting:       "Meeting",
    conference:    "Conference",
    banquet:       "Banquet",
    wedding:       "Wedding",
    corporateEvent:"Corporate event",
    other:         "Other",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    saved:                "Reservation updated",
    cancelled:            "Reservation cancelled",
    correctionRequired:   "Please correct the highlighted reservation errors.",
    groupCorrectionRequired:"Please correct the highlighted group reservation errors.",
    noEmail:              "No recipient email address for this reservation.",
    confirmationSent:     "Confirmation email sent.",
    depositCaptured:      "Deposit captured.",
  },

} as const;

export default enPmsReservations;
